import { call, getContext } from 'redux-saga/effects';
import * as _ from 'lodash-es';

import repositoryApi from '../../Api/repository';
import { toQueryProperties } from '../../Utils/projectUtils';
import { parseGatewayResources } from '../../Utils/documentUtils';
import { updateDocuments } from './documentSelectionSaga';


/**
 * Generates a dependency map for the given properties
 * @param properties
 * @returns {{[p: string]: any}|{}}
 */
export function generatePropertiesDependencyMap(properties) {
  if (!properties) return {};

  return _.chain(properties)
    .filter((prop) => prop.isDependant())
    .keyBy('name')
    .mapValues('dependency')
    .value();
}

/**
 * Get all properties that depend on the given parentPropertyName
 * @param dependencyMap
 * @param parentPropertyName
 * @returns {string[]}
 */
export function getDependantProperties(dependencyMap, parentPropertyName) {
  const children = Object.keys(dependencyMap).filter(
    (key) => dependencyMap[key] === parentPropertyName
  );

  children.forEach((child) => {
    children.push(...getDependantProperties(dependencyMap, child));
  });

  return children;
}

export function* addURLtoResources(resources) {
  const projectService = yield getContext('projectService');
  const project = yield call(projectService.getOpenedProject);

  const getResourceUrl = (resource) => {
    let parts = [];

    const projectCode = project?.code;
    if (projectCode != null) {
      parts = [...parts, 'module', projectCode];
    }

    switch (resource.resourcetype) {
      case 1:
        parts = [...parts, 'folder', resource.identifier];
        break;
      case 2:
        parts = [...parts, 'document', resource.identifier];
        break;
      default:
        break;
    }

    return window.location.origin + '/' + parts.join('/');
  };

  return {
    resourcesWithUrls: resources.map((r) => ({
      ...r,
      url: getResourceUrl(r),
    })),
    project,
  };
}

export function* fetchDocumentsByIds(folderId, documentIds) {
  const projectService = yield getContext('projectService');
  const properties = yield call(projectService.getProperties);
  const requestedProps = toQueryProperties(properties);

  try {
    const items = yield call(
      repositoryApi.getDocumentsByIds,
      folderId,
      documentIds,
      requestedProps
    );
    const documents = parseGatewayResources(items, properties);
    return documents;
  } catch (err) {
    console.error(err);
  }

  return [];
}
